<template>
  <div class="row p-0">
      <template v-if="data_available">
        <div class="col-4">
          <GenericBarChart
            :data="year_data"
            label-field="year"
            contracts-field="contracts"
            amount-field="amount"
            title-x="Año"
          />
        </div>
        <div class="col-4">
          <GenericBarChart
            :data="cpv_data"
            label-field="key"
            contracts-field="contracts"
            amount-field="amount"
            title-x="CPV"
          />
        </div>
        <div class="col-4">
          <GenericBarChart
            :data="contract_type_data"
            label-field="key"
            contracts-field="contracts"
            amount-field="amount"
            title-x="Tipo de contrato"
          />
        </div>
        <div class="col-4">
          <GenericBarChart
            :data="tenders_per_location"
            label-field="key"
            contracts-field="contracts"
            amount-field="amount"
            title-x="Localizacion"
          />
        </div>
        <div class="col-4">
          <GenericBarWithGoals
                :data="top_awarded_parties"
                label-field="key"
                contracts-field="contracts"
                amount-field="amount"
                goal-field="bajaPct"
                title-x="Top 10 adjudicatarias por importe"
              />
        </div>
        <div class="col-4">
          <GenericBarWithGoals
                :data="top_contracting_parties"
                label-field="key"
                contracts-field="contracts"
                amount-field="amount"
                goal-field="bajaPct"
                title-x="Top 10 contratistas por importe"
              />
        </div>
      </template>
      <template v-else>
        <p>No hay datos disponibles para mostrar los gráficos.</p>
      </template>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import GenericBarChart from '@/components/helpers/generic_bar_chart.vue';
import GenericBarWithGoals from '@/components/helpers/generic_bar_goals_chart.vue';
import procurementChartsMixin from '@/_mixins/procurement_charts.mixin';

export default {
  name: 'ProcurementCharts',
  components: {
    GenericBarChart,
    GenericBarWithGoals,
  },
  mixins: [procurementChartsMixin],
  computed: {
    ...mapState({
      projects_stats: state => state.procurementModule.projects_stats,
    }),
  },
};
</script>
